import { SYMMETRICKEYS } from '../actionTypes';

export const fetchSymmetrickey = (action) => ({
  type: SYMMETRICKEYS.FETCH,
  payload: action.payload,
});
